import Role from "./Role";

export default class OrganizationUser {
  public id: string
  public subdivision: string
  public firstName: string
  public lastName: string
  public email: string
  public dateAdded: string
  public preferredLanguageId: string
  public roles: Role[]
  public assets: any[]
  public state: {
    name: string
    id: number
  }
  public identityProvider: string
  public termsAndConditionsVersion: string
  public termsAndConditionsTarget: string
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/OrganizationUser.ts